<template>
  <div>
    学而不思则罔，思而不学则殆：
    <br />只是学习却不思考就会迷惑而无所得，只是思考却不学习就会精神疲倦而无所得。
  </div>
</template>

<script>
export default {
  name: "chinesePage",
};
</script>

<style scoped>
div {
  padding-left: 30%;
  padding-right: 30%;
  text-align: left;
}
</style>
